<div class="text-black" *ngIf="barcode$ | async as barcode">
  <div class="p-0 d-flex flex-wrap flex-column justify-content-around align-items-center w-100">
    <ng-container *ngIf="card$ | async as card">
      <!--Name and ID-->
      <div class="w-100 bg-primary barcode-content-container" [ngClass]="{ 'kid-barcode-container': isKid && showWallet }">
        <div class="barcode-content bg-primary text-black d-flex flex-column" *ngIf="card$ | async as card">
          <div class="info-box" *ngIf="showWallet">
            <!--Name and ID-->
            <div>
              <div
                class="font-size-14 text-uppercase font-heading text-white fw-bold"
                *ngIf="memberDetails$ | async as memberDetails"
              >
                {{ memberDetails.FirstName + ' ' + memberDetails.Surname }}
              </div>
              <div class="d-flex productcode text-white font-size-12">
                <div>{{ 'product.code.' + stripSpaces(card.ProductCode).toLowerCase() | translate }}</div>
                <div class="px-1">-</div>
                <div>{{ card.ExternalRefNumber }}</div>
              </div>
            </div>
            <div>
              <button
                class="wallet-btn d-flex align-items-center justify-content-center btn gloss text-white font-heading mt-0 w-100 font-size-14"
                [routerLink]="['/rewards/wallet']"
              >
                <span class="material-icons me-2 font-size-20 text-center walleticon">qr_code_scanner </span>
                <span class="font-size-14 lh-1">{{ 'nav.wallet' | translate }}</span>
              </button>
            </div>
          </div>
          <div *ngIf="showBarcode">
            <div class="qr gloss flex-column">
              <div class="qr-code-box">
                <qrcode [qrdata]="barcode.Barcode" [width]="120" [errorCorrectionLevel]="'M'" [elementType]="'svg'"></qrcode>
              </div>
              <p class="font-size-12 text-white mb-0 text-center w-100">
                {{ 'wallet.barcode.scan' | translate }}
              </p>
              <!--Mobile Pass-->
              <ng-container *ngIf="!isKid">
                <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.mobile.pass'">
                  <ng-container *ngIf="member$ | async as member">
                    <div class="mt-3">
                      <fgbcl-mobile-pass [memberId]="member.MemberId"></fgbcl-mobile-pass></div
                  ></ng-container>
                </ng-container>
                <!--Balance-->
                <div class="d-flex justify-content-between align-items-center w-100 font-size-14 text-white mt-2">
                  <span>{{ 'member.card.balance' | translate : { fgbdefault: 'Balance' } }}</span>
                  <span class="fw-bold">{{ combinedCard$ | async | FortressCurrencyPipe }}</span>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
